import { ListItemAvatar, ListItemText, Menu, MenuItem } from '@mui/material';
import type { Editor } from '@tiptap/core';
import type { PopoverProps } from 'src/components/PopoverTrigger';
import Iconify from 'src/components/iconify';
import { useDragHandlerStore } from '../states/TableHandlerState';

export const TableRowOptionsPopover = ({
  target,
  handleClose,
  editor,
}: PopoverProps<{ editor: Editor }>) => {
  const rowNodePos = useDragHandlerStore((state) => state.rowNodePos);
  const currentRowIndex = useDragHandlerStore((state) => state.currentRowIndex);

  const node = editor.$pos(rowNodePos!).node;
  const isRowHeader = node.type.name === 'tableHeader';

  return (
    <Menu anchorEl={target} open onClose={handleClose}>
      <MenuItem
        onClick={() => {
          editor.chain().focus(rowNodePos).addRowBefore().run();
          handleClose();
        }}
      >
        <ListItemAvatar>
          <Iconify icon="tabler:row-insert-top" />
        </ListItemAvatar>
        <ListItemText primary="Add row before" />
      </MenuItem>
      <MenuItem
        onClick={() => {
          editor.chain().focus(rowNodePos).addRowAfter().run();
          handleClose();
        }}
      >
        <ListItemAvatar>
          <Iconify icon="tabler:row-insert-bottom" />
        </ListItemAvatar>
        <ListItemText primary="Add row after" />
      </MenuItem>
      {currentRowIndex === 0 && (
        <MenuItem
          onClick={() => {
            editor.chain().focus(rowNodePos).toggleHeaderRow().run();
            handleClose();
          }}
        >
          {isRowHeader ? (
            <>
              <ListItemAvatar>
                <Iconify icon="tabler:table" />
              </ListItemAvatar>
              <ListItemText primary="Turn into row" />
            </>
          ) : (
            <>
              <ListItemAvatar>
                <Iconify icon="tabler:table-row" />
              </ListItemAvatar>
              <ListItemText primary="Turn into header" />
            </>
          )}
        </MenuItem>
      )}
      <MenuItem
        onClick={() => {
          editor.chain().focus(rowNodePos).deleteRow().run();
          handleClose();
        }}
      >
        <ListItemAvatar>
          <Iconify icon="tabler:row-remove" />
        </ListItemAvatar>
        <ListItemText primary="Delete row" />
      </MenuItem>
    </Menu>
  );
};
